import { useDispatch, useSelector } from "react-redux";
import { workQCallFollowupUpdate } from "../../../../../lib/fetchApi";
import { notificationActions } from "../../../../../store/notifications";
import { filterActions } from "../../../../../store/filter";
import FollowUpQStatusItem from "./FollowUpQStatusItem";

export default function FollowUpQStatus({classes, item, items, workQtype}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const currentUser = useSelector(state => state.user.user)



    async function updateHandler(data) {
        let reqBody = {
            [data.identifier.field] : data.data.value,
        }     

        const fields = [
            {
                field: data.identifier.field,
                value: data.data.value
            },
        ]

        if (data.identifier.field?.includes('_status')) {
            fields.push({
                field: data.identifier.field.replace('_status', '_user'),
                value: {
                    id: currentUser?.id || null,
                    name: currentUser?.name || null,
                    email: currentUser?.email || null
                }
            })
        }

        let dispatchObj = {
            case_id: item?.case?.id,
            appointment_id: item?.appointment?.id,
            folder: 'workq_call_follow_up',
            item: {
                fields
            }
        }
        dispatch(filterActions.updateItemInWorkQRow(dispatchObj))

        let update = await workQCallFollowupUpdate(userToken, item.appointment.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            
            dispatch(notificationActions.setError({errorMessage: `Your changes have been successfully saved to the case.`, type: 'success'}))

            // setTimeout(() => {
            //dispatch(workqueueActions.setRefreshApi())
            // }, workQueueRefreshApiTimeout());
        }    
                
    }

    return <>
        {/* day 1 status  */}  
        {/* <td className={`${classes.td_cell_no_padding}`}>
            {item.patient && <>
                <CustomSelect optionsData={frontendOptions()?.CALL_FOLLOW_UP_STATUS} preSelectedValue={item.workq_call_follow_up.day_1_status} action={updateHandler} name={'day_1_status'} identifier={{type: 'workq_call_follow_up', field: 'day_1_status', type_id: null, folder: null, case_id: item.case?.id}} sameSizeAsContainer={true} minWidth={150}/>                           
            </>}
        </td>   */}

        {/* day 2 status  */}  
        {/* <td className={`${classes.td_cell_no_padding}`}>
            {item.patient && <>
                <CustomSelect optionsData={frontendOptions()?.CALL_FOLLOW_UP_STATUS} preSelectedValue={item.workq_call_follow_up.day_2_status} action={updateHandler} name={'day_2_status'} identifier={{type: 'workq_call_follow_up', field: 'day_2_status', type_id: null, folder: null, case_id: item.case?.id}} sameSizeAsContainer={true} minWidth={150}/>                           
            </>}
        </td>  */}


        {items && items.map(elem => (
            <FollowUpQStatusItem key={elem.type} type={elem.type} updateHandler={updateHandler} item={item} classes={classes} workQtype={workQtype}/>
        ))}
    </>
}